import AuthenticityTokenInput from "../AuthenticityTokenInput"
const baseProjectPath = window.location.pathname.match(/\/recruiter\/[^/]+/)![0]

export default function RecruiterHeader({
  buttons = []
}: {
  buttons: ("dev-login" | "logout")[]
}) {
  return (
    <header className="flex items-center justify-between px-6 py-4 md:px-12 md:py-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-lg">R</span>
        </div>
        <div className="flex flex-col">
          <span className="text-primary-500 font-semibold text-lg leading-tight">
            Respons
          </span>
          <span className="text-primary-500 text-sm leading-tight">
            Rekruteringsplatform
          </span>
        </div>
      </div>
      <div className="flex flex-row gap-4">
        {buttons.includes("dev-login") && (
          <form action={`${baseProjectPath}/dev_login`} method="post">
            <AuthenticityTokenInput />
            <button
              type="submit"
              className="px-4 py-2 text-sm text-neutral-600 bg-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors"
              data-testid="demo-login-button"
            >
              Dev login
            </button>
          </form>
        )}

        {buttons.includes("logout") && (
          <form action={`${baseProjectPath}/sessions`} method="post">
            <AuthenticityTokenInput />
            <input type="hidden" name="_method" value="delete" />
            <button
              type="submit"
              className="px-4 py-2 text-sm text-neutral-600 bg-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors"
            >
              Log ud
            </button>
          </form>
        )}
      </div>
    </header>
  )
}
